/* ----- Controller: manageNonProfitEasyController ----- */
(function(){
    // add the controller
    SUGApp.controller('manageNonProfitEasyController', manageNonProfitEasyController);

    manageNonProfitEasyController.$inject = ['$scope','$filter','$location','$uibModal','$q','$sce','$templateCache','$timeout','$window','sugCacheFactory','SUGUtilities','errorService','globalService','integrationService','settingService','routeparams'];
    function manageNonProfitEasyController(   $scope, $filter, $location, $uibModal, $q, $sce, $templateCache, $timeout, $window, sugCacheFactory, SUGUtilities, errorService, globalService, integrationService, settingService, routeparams ) {

        /* init vars */
        $scope.isProcessing = false;
        $scope.loaded = false;
        $scope.frmObj = {};
        $scope.frmObj.searchFilter = '';
        $scope.frmObj.checkAll = false;
        $scope.dateFormat = '';
        $scope.sync = {
              general:      {}
            , volunteer:    {slots:'ignoreall'}
        };
        $scope.frmDisableField = false;
        $scope.fullsecureurl = ( typeof window.globalcfg.secureURL != 'undefined' ) ? window.globalcfg.secureURL : 'https://www.signupgenius.com';
        var reg = /^https?:\/\//;
        $scope.secureurl = $scope.fullsecureurl.replace(reg,'');
        $scope.npeSignups = [];
        $scope.npeSignupsFiltered = [];
        $scope.synctypes = [];
        $scope.commentlen = $window.innerWidth < 1200 ? 28 : 58;
        $scope.hoursmax = 3;

        var _userdef = {};
        var signupsToSave = [];

        /* These will be set by view controllers */
        $scope.strings = {
              asc:                      'ASC'
            , desc:                     'DESC'
            , savebtn:                  'Save'
            , cancelbtn:                'Cancel'
            , dateFormat:               'yyyy-MM-dd'
            , itemsPerPageInvalid:      'Items per page must be a number greater than 0.'
            , confirmTitle:             'Are you sure?'
            , syncConfirmBody:          'NonProfitEasy syncing will automatically apply to sign up activity that occurs after the sync is enabled. If there is sign up activity on this sign up that existed prior to enabling syncing or there was a gap in the data sync for some other reason, you can use this option to resync the data for this sign up.'
            , syncConfirmButton:        'Yes, Resync'
            , syncSuccessMsg:           'A resync was successfully scheduled for the sign up. It may take several minutes for the process to complete.'
            , disableConfirmBody:       'The NonProfitEasy integration will be disabled and data syncing will be stopped.'
            , disableConfirmButton:     'Yes, Disable'
            , disableSuccessMsg:        'Your NonProfitEasy integration has been disabled and syncing has stopped for all sign ups.'
            , saveVolSuccessMsg:        'The volunteering settings have been saved for the specific sign up.'
            , changeSyncConfirmBody:    '<p>Sign up activity has already been synced using the "!oldType!" sync type. Changing the sync type will cause all previously synced sign up activity to be removed.</p><p>Syncing will continue based on the "!newType!" sync type from this point forward.</p><p>Perform a full resync if you need older sign up activity to be re-synced under the new sync type.</p>'
            , changeSyncConfirmButton:  'Yes, Change Sync Type'
            , noPermission:             'Sorry, you do not have permission to access that page.'
            , saveSuccessMsg:           'Your NonProfitEasy integration settings have been saved successfully.'
            , validationError:          'There was an issue saving the sign up titled "!signupName!". Please try again.'
            , saveSyncSettingsError:    'There was an issue saving the sync settings.'
            , syncTypeChgSuccessMsg:    'The sign up sync type has been changed successfully. It may take several minutes to see the change in your NonProfitEasy account.'
            , itemsPerPageInvalid:      'Items per page must be a number greater than 0.'
            , errorDetailTitle:         'Sync Error'
            , errorDetailConfirmBody:   '<p>The following sync error occurred:</p><p style="color:#92282E;padding-left:24px; width:90%;">!errorText!</p><p style="margin-bottom:0px;">Please retry or <a href="/help" target="_blank">contact support</a> for assistance.</p>'
            , errorDetailConfirmButton: 'Retry Sync'
            , resetSyncJobSuccessMsg:   'The sign up sync task has been scheduled to re-run. Please wait several minutes for the process to complete.'
            , errors: {
                  errorsTitle: ''
                , errorsPleaseCorrect: 'Please correct the following issues:'
            }
            , page: {
                  title:        'NonProfitEasy Integration'
                , instructions: 'Select the sign ups that you would like to sync below. Any sign ups that are enabled for syncing will have participant activity synced from that point forward. If your sign up already has participant data that has not been synced, you can perform a refresh to sync that data on-demand. The sync type determines whether data is synced as general event or volunteering data within NonProfitEasy. For Volunteering sign ups, you can specify optional settings or use the defaults at the bottom of this page.'
                , disable:      'If you would like to remove this integration from all of your sign ups and stop syncing data to NonProfitEasy, you can '
                , disablelink:  'disable your NonProfitEasy integration'
            }
            , table: {
                  title:                'Manage Sign Up Sync'
                , headersignup:         'Sign Up Title'
                , headersync:           'Last Sync Date'
                , headertype:           'Sync Type'
                , noData:               'There are no published sign ups. Once you have published one or more sign ups, they will be listed here.'
                , noFilteredData:       'No data matched your search criteria. Please try again.'
                , settingsicon:         'Volunteering Settings'
                , settingsdisabledicon: 'Not Available'
                , resyncicon:           $sce.trustAsHtml('Resync this sign up')
                , resynciconpending:    'Pending'
                , resynciconerror:      $sce.trustAsHtml('Error, click for details.')
                , rsvpresyncicon:       $sce.trustAsHtml('Resync is not available for RSVP format sign ups. Please <a href="/help" target="_blank" style="display:inline;">contact support</a> for assistance.')
                , selecttype:           'Select sign up type'
                , selectitem:           'Sign up selected for syncing'
                , enabled:              $sce.trustAsHtml('Enabled')
                , disabled:             $sce.trustAsHtml('Disabled')
                , rsvptip:              $sce.trustAsHtml('Syncing is not available for RSVP format sign ups. Please <a href="/help" target="_blank">contact support</a> for assistance.')
            }
            , general: {
                  title:        'Integration Settings'
                , enablesync:   'Automatically enable syncing for all new sign ups'
                , synctip:      'If enabled, any newly created sign up will automatically be enabled for sync and the Sync Type will be set to Volunteering only if the Sign Up Type is set to Volunteering as well.'
            }
            , volunteer: {
                  title:         'Volunteering Settings'
                , instructions:  'For volunteering sign ups, we calculate the volunteer hours using the start and end time on the sign up slots. When sign up slots do not have start and end times, what would you like to do'
                , modalspecific: ' for this specific sign up'
                , note:          'NOTE: You can apply sign up specific volunteer hour calculation rules using the volunteer settings gear icon in the grid view above. Sign up specific settings will override this default for any sign ups that have them.'
                , usedefault:    'Use default integration setting'
                , ignoreslots:   'Ignore those slots'
                , defaulthoursA: 'Assign a default of'
                , defaulthoursB: 'hours to those slots'
                , numberhours:   'Number of hours'
                , settingserror: 'An error occurred updating the volunteering settings for that sign up. Please try again.'
           }
           , settings: {
                  itemsPerPage:      'Items Per Page'
                , saveButton:        'Save'
                , saveSettings:      'Save Settings'
                , settingsPopover:   'Settings'
                , sortBy:            'Sort By'
                , sortOrder:         'Sort Order'
                , categoryName:      'ManageIntegrations'
                , settingsName:      'manage_npe'           //standard user settings
                , syncSettingsName:  'manage_npe_sync'      //general and volunteer sync settings
                , titlelbl:          'Sign Up Title'
                , datelbl:           'Last Sync Date'
                , typelbl:           'Sync Type'
           }
        };

        $scope.statusmsg_npe = {
            type:         'success'
          , title:        ''
          , text:         ''
          , dismissable:  true
          , show:         false
          , noshadow:     true
          , reset:        true
        };

        /* Sort Options for Settings Popover */
        $scope.sortOptions = [
            { label: $scope.strings.asc , value: false },
            { label: $scope.strings.desc , value: true }
        ];

        /* UIB-Popover vars */
        $scope.popover = {
            popTrig: 'mouseenter',
            popPlacement: 'top',
            popDelay: 300,
            appendToBody: false
        };

        /* Pagination */
        $scope.recordCount = 0;
        $scope.pagination = {
            currentPage: 1,
            maxSize: 5,
            numPerPage: 5
        };

        $scope.getActivePopover = function(su){
            return su.isrsvp ? $scope.strings.table.rsvptip : su.isactive ? $scope.strings.table.enabled : $scope.strings.table.disabled;
        };

        $scope.getResyncPopover = function(su){
            var popover = '';
            if( su.isrsvp ){
                popover = $scope.strings.table.rsvpresyncicon;
            } else if( su.jobstatus == 'Pending'){
                popover = $scope.strings.table.resynciconpending;
            } else if( su.jobstatus == 'Error'){
                popover = $scope.strings.table.resynciconerror;
            } else {
                popover = $scope.strings.table.resyncicon;
            }
            return popover;
        };

        /* Pagination template with sugicons */
        $templateCache.put('template/pagination/pagination.html',
            "<ul class=\"pagination\">\n" +
            "  <li ng-if=\"boundaryLinks\" ng-class=\"{disabled: noPrevious()}\"><a href ng-click=\"selectPage(1)\"><span class=\"sugicon-arrow-left-thick\"></span></a></li>\n" +
            "  <li ng-if=\"directionLinks\" ng-class=\"{disabled: noPrevious()}\"><a href ng-click=\"selectPage(page - 1)\"><span class=\"sugicon-arrow-thin-left-thin\"></span></a></li>\n" +
            "  <li ng-repeat=\"page in pages track by $index\" ng-class=\"{active: page.active}\"><a href ng-click=\"selectPage(page.number)\">{{page.text}}</a></li>\n" +
            "  <li ng-if=\"directionLinks\" ng-class=\"{disabled: noNext()}\"><a href ng-click=\"selectPage(page + 1)\"><span class=\"sugicon-arrow-thin-right-thin\"></span></a></li>\n" +
            "  <li ng-if=\"boundaryLinks\" ng-class=\"{disabled: noNext()}\"><a href ng-click=\"selectPage(totalPages)\"><span class=\"sugicon-arrow-right-thick\"></span></a></li>\n" +
            "</ul>");


        //init error service
        $scope.es = errorService;
        $scope.es.init();


        // Handler for Processing Status
        $scope.$on('isProcessing', function (event, processing) {
            $scope.isProcessing = processing;
            if ($scope.isProcessing) {
                SUGUtilities.showLoading('processing');
                $scope.frmDisableField = true;
            } else {
                $scope.frmDisableField = false;
            }
        });

        /* Scroll to top on successful route */
        $scope.$on('$routeChangeSuccess', function(){
            $window.scrollTo(0,0);
        });

        /* Settings Dropdown Click Handler */
        $scope.dropDownClickEvent = function(e) {
            if( typeof e.target.title !== 'undefined'
                && e.target.title === $scope.strings.settings.saveSettings){
                saveUserSettings();
            } else {
                e.stopPropagation();
            }
        };


        /**
         * Method starts the workflow
         */
        var init = function() {
            SUGUtilities.broadCast('isProcessing', true);

            //get the memberId from cache
            _hasNpeFeature = sugCacheFactory.get('integration_hasNPEFeature', false);

            if( _hasNpeFeature ){
                loadSettings();
            } else {
                //If we can't verify the NPE feature from the call on the initial page, check here
                integrationService.checkNPEAccess( routeparams )
                .then(function(hasAccess){
                    if( hasAccess ){
                        //save result in local factory
                        sugCacheFactory.set('integration_hasNPEFeature', hasAccess);

                        //clear any previous statuses on the main page
                        $scope.$parent.sug_integrations.statusmsg.text = '';
                        $scope.$parent.sug_integrations.statusmsg.show = false;
                        $scope.$parent.sug_integrations.statusmsg.type = 'success';
                        $scope.$parent.sug_integrations.updateManageBtn('npe','Manage Integration');

                        loadSettings();
                    } else {
                        //If the session times out just re-call init
                        init();
                    }
                }, function(err){
                    noAccess();
                });
            }

        };

        /**
         * Method handles when access is denied
         */
        var noAccess = function(){
            //set a warning message and sent the user back to the main integration settings page
            $scope.$parent.sug_integrations.statusmsg.text = $scope.strings.noPermission;
            $scope.$parent.sug_integrations.statusmsg.show = true;
            $scope.$parent.sug_integrations.statusmsg.type = 'danger';
            SUGUtilities.broadCast('isProcessing', false);
            $location.path( "/" );
        };


        /************************
         MANAGE DATA
        ************************/

        /**
         * Method loads data needed for the page in view
         */
        var loadSettings = function() {

            getDateAndTZFormats()
            .then(function(dateAndTZFormats){
                var arrDF = dateAndTZFormats.dateformats;
                for(var i = 0, len = arrDF.length; i < len; i++){
                    var val = arrDF[i];
                    if(val.selected){
                        $scope.dateFormat = val.short.replace('mm', 'MM');
                        $scope.strings.dateFormat = val.short;
                        break;
                    }
                }

                //load member form settings
                settingService.getSettingByName( $scope.strings.settings.settingsName, $scope.strings.settings.categoryName )
                .then(function(frmSettings){
                    sugCacheFactory.set('frmObj', frmSettings);

                        //load the NPE default sync settings
                        settingService.getSettingByName( $scope.strings.settings.syncSettingsName, $scope.strings.settings.categoryName)
                        .then(function(syncSettings){
                            sugCacheFactory.set('sync', syncSettings);

                            //update sync model with stored data or defaults
                            $scope.sync = Object.keys(syncSettings).length ? syncSettings : { general:{} , volunteer:{slots:'ignoreall'} };
                            //store the sync setting id
                            $scope.syncSettingID = $scope.sync.hasOwnProperty('settingID') ? $scope.sync.settingID : 0;

                            loadData();

                        }); //getSettingByName sync
                }); //getSettingByName user
            }); //DateTime .then
        };

        /**
         * Method loads data needed for the page in view
         */
        var loadData = function(){
            //load frmObj from cache
            $scope.frmObj = sugCacheFactory.get('frmObj',{});

            //default the user settings
            prepareUserSettings();

            //get the memberId from cache
            _userdef = sugCacheFactory.get('integration_userdef', {});

            getNPESyncTypes()
            .then(function(types){
                // set syncTypes array
                $scope.synctypes = types;

                getNPESignups()
                .then(function(signups){
                    // set NPE signups array
                    $scope.npeSignups = signups;

                    // after data is loaded do some processing
                    for(var i=0, len=$scope.npeSignups.length; i<len; i++){

                        //Before adjustments, save a copy of any previosuly saved signup in a 2nd Array for saving later
                        if( $scope.npeSignups[i].integrationsyncid > 0 ){
                            signupsToSave.push( angular.copy( $scope.npeSignups[i] ) );
                        }

                        //Convert the 1/0 to true/false for the UI
                        $scope.npeSignups[i].isdefault = !!$scope.npeSignups[i].isdefault;
                        $scope.npeSignups[i].isrsvp = !!$scope.npeSignups[i].isrsvp;
                        $scope.npeSignups[i].isactive = $scope.npeSignups[i].isrsvp ? false : !!$scope.npeSignups[i].isactive;

                        //if the lastsyncepoch date is empty, then populate it with lastsyncsuccessepoch for date sorting
                        $scope.npeSignups[i].lastsyncepoch = !$scope.npeSignups[i].lastsyncepoch.toString().trim().length ? $scope.npeSignups[i].lastsyncsuccessepoch : $scope.npeSignups[i].lastsyncepoch;

                        //Add a formatted sync date so we don't need to format date on the fly in the view or search code
                        //2-step date conversion handles issue where if the regular epoch date is formatted, if its time is midnight, the date will appear one day behind
                        var jstatus = $scope.npeSignups[i].jobstatus.toString().trim();
                        var epoch = $scope.npeSignups[i].lastsyncepoch.toString();
                        var epochsuccess = $scope.npeSignups[i].lastsyncsuccessepoch.toString();

                        if(jstatus == 'Pending' || jstatus == 'Processing'){
                            $scope.npeSignups[i].syncdateformatted = 'Pending';
                        } else if( jstatus == 'Error' && epochsuccess.length ){
                            var parsedDate = SUGUtilities.utcToLocalDate( new Date( $scope.npeSignups[i].lastsyncsuccessepoch ) );
                            $scope.npeSignups[i].syncdateformatted = $filter("date")(parsedDate, $scope.dateFormat);
                        } else if( jstatus == 'Error' ){
                            $scope.npeSignups[i].syncdateformatted = 'Error';
                        } else if( epoch.length ){
                            var parsedDate = SUGUtilities.utcToLocalDate( new Date( $scope.npeSignups[i].lastsyncepoch ) );
                            $scope.npeSignups[i].syncdateformatted = $filter("date")(parsedDate, $scope.dateFormat);
                        } else {
                            $scope.npeSignups[i].syncdateformatted = 'Never';
                        }

                        //format the result (error)
                        if( $scope.npeSignups[i].jobresult.trim().length && $scope.npeSignups[i].jobresult.split(':').length > 1){
                            $scope.npeSignups[i].jobresult = $scope.npeSignups[i].jobresult.split(':')[1];
                        }
                    }

                    // prep $scope data
                    $scope.npeSignupsFiltered = angular.copy( $scope.npeSignups );
                    $scope.recordCount = $scope.npeSignupsFiltered.length;

                    filterData();

                    initializeDirtiness();
                    $scope.loaded = true;
                    SUGUtilities.broadCast('isProcessing', false);

                }); // END getNPESignups

            });

        };


        /**
         * Get the NPE Sign Up data
         */
        var getNPESignups = function(){
            SUGUtilities.broadCast('isProcessing', true);

            var deferred = $q.defer();

            integrationService.getNPESignups()
            .then(function (response) {
                if (SUGUtilities.ajaxResultInvalid(response)) {
                    // invalid response, show error
                    $scope.es.setError('manage_integrations', SUGUtilities.getAjaxResponseMessage(response) );
                    SUGUtilities.broadCast('isProcessing', false);
                    deferred.reject();
                } else {
                    // successful - set some vars later use
                    var r = SUGUtilities.lowerCaseKeys(response);
                    deferred.resolve(r.data.data);
                }
            });
            return deferred.promise;
        };

        /**
         * Method checks to see if the controlled features are enabled
         */
        var getNPESyncTypes = function(){
            var deferred = $q.defer();
            integrationService.getNPESyncTypes()
            .then(function (response) {
                if (SUGUtilities.ajaxResultInvalid(response)) {
                    // invalid response, show error
                    $scope.es.setError('manage_integrations', SUGUtilities.getAjaxResponseMessage(response) );
                    SUGUtilities.broadCast('isProcessing', false);
                    deferred.reject();
                } else {
                    // successful, return types
                    var r = SUGUtilities.lowerCaseKeys(response);
                    deferred.resolve(r.data.data);
                }
            });
            return deferred.promise;
        };


        /**
         * Get the user's preferred Date Format
         */
        var getDateAndTZFormats = function() {
            var deferred = $q.defer();
            var dateAndTZFormats = sugCacheFactory.get('dateAndTZFormats', {});

            if (Object.keys(dateAndTZFormats).length === 0){
                globalService.getDateAndTZFormats()
                    .then(function (response) {
                        var r = SUGUtilities.lowerCaseKeys(response);
                        if (r.data && r.data.data) {
                            dateAndTZFormats = r.data.data;
                            sugCacheFactory.set('dateAndTZFormats', dateAndTZFormats);
                        }
                        deferred.resolve(dateAndTZFormats);
                });
            } else {
                deferred.resolve(dateAndTZFormats);
            }

            return deferred.promise;
        };

        /**
         * Method defaults user saves settings for sorting, filter, etc.
         */
        var prepareUserSettings = function() {
            $scope.settingID = $scope.frmObj.hasOwnProperty('settingID') ? $scope.frmObj.settingID : 0;

            if( !$scope.frmObj.hasOwnProperty('searchFilter') ){ $scope.frmObj.searchFilter = ''; }
            if( !$scope.frmObj.hasOwnProperty('orderColumn') ){ $scope.frmObj.orderColumn = 'title'; }
            if( !$scope.frmObj.hasOwnProperty('direction') ){ $scope.frmObj.direction = false; }
            if( !$scope.frmObj.hasOwnProperty('numPerPage') ){ $scope.frmObj.numPerPage = 5; }
            if( !$scope.frmObj.hasOwnProperty('checkAll') ){ $scope.frmObj.checkAll = false; }

            $scope.arrowDir =  $scope.frmObj.direction ? 'sugicon-arrow-down-thick' : 'sugicon-arrow-up-thick';
            $scope.pagination.numPerPage = $scope.frmObj.numPerPage;
        };


        /* Column Direct Sort */
        $scope.setSort = function (columnKey) {
            $scope.frmObj.orderColumn = columnKey;
            $scope.frmObj.direction = !$scope.frmObj.direction;
            $scope.arrowDir = $scope.frmObj.direction ? 'sugicon-arrow-down-thick' : 'sugicon-arrow-up-thick';
            filterData();
        };

        /* Apply Settings/Filter */
        var filterData = function() {
            if ($scope.frmObj.searchFilter !== '') {
                $scope.npeSignupsFiltered = $filter('filter')($scope.npeSignups, $scope.searchNpeSignups);
                $scope.npeSignupsFiltered = $filter('orderBy')($scope.npeSignupsFiltered, $scope.frmObj.orderColumn, $scope.frmObj.direction);
            } else {
                $scope.npeSignupsFiltered = $filter('orderBy')($scope.npeSignups, $scope.frmObj.orderColumn, $scope.frmObj.direction);
            }
            $scope.recordCount = $scope.npeSignupsFiltered.length;

            // Apply Pagination
            if ($scope.npeSignupsFiltered.length) {
                var begin = ($scope.pagination.currentPage - 1) * parseInt($scope.pagination.numPerPage);
                var end = begin + parseInt($scope.pagination.numPerPage);
                $scope.npeSignupsFiltered = $scope.npeSignupsFiltered.slice(begin, end);

                // If end up with no results, recursively step back until we get valid paged results
                if (!$scope.npeSignupsFiltered.length && $scope.pagination.currentPage > 1) {
                    $scope.pagination.currentPage--;
                    filterData();
                }
            }
        };

        /**
         * Method filters table data based on search value
         */
        $scope.searchNpeSignups = function(objSignup){
            if( !$scope.frmObj.searchFilter
                || objSignup.listid == $scope.frmObj.searchFilter
                || objSignup.title.toString().toLowerCase().indexOf( $scope.frmObj.searchFilter.toString().toLowerCase() ) > -1
                || objSignup.synctypekey.toString().toLowerCase().indexOf( $scope.frmObj.searchFilter.toString().toLowerCase() ) > -1
                || objSignup.syncdateformatted.toString().toLowerCase().indexOf( $scope.frmObj.searchFilter.toString().toLowerCase() ) > -1
                ){
                return true;
            } else {
                return false;
            }
        };


        /**
         * Method saves standard user settings
         */
        var saveUserSettings = function() {
            SUGUtilities.broadCast('isProcessing', true);

            var revertSettings = sugCacheFactory.get('frmObj');
            var settingsObj = {
                orderColumn: $scope.frmObj.orderColumn,
                direction: $scope.frmObj.direction,
                numPerPage: $scope.frmObj.numPerPage
            };
            sugCacheFactory.set( 'frmObj', settingsObj );

            settingService.saveSettings($scope.settingID, $scope.strings.settings.settingsName, $scope.strings.settings.categoryName, settingsObj)
            .then(
                function (settingId) {
                    $scope.settingID = settingId;
                },
                function (response) {
                    // revert settings
                    $scope.frmObj = revertSettings;
                    sugCacheFactory.set( 'frmObj', revertSettings );
                    SUGUtilities.ajaxErrorHandler(response.data);
                }
            );
            SUGUtilities.broadCast('isProcessing', false);
        };

        /**
         * Method saves default NPE Sync settings
         */
        var saveDefaultSyncSettings = function() {
            var backupSettings = sugCacheFactory.get('sync');
            var syncObj = angular.copy( $scope.sync );

            sugCacheFactory.set( 'sync', syncObj );

            settingService.saveSettings($scope.syncSettingID, $scope.strings.settings.syncSettingsName, $scope.strings.settings.categoryName, syncObj)
            .then(
                function (syncsettingid) {
                    $scope.syncSettingID = syncsettingid;
                },
                function (response) {
                    // revert sync settings
                    $scope.sync = backupSettings;
                    sugCacheFactory.set( 'sync', backupSettings );
                    $scope.es.setError('manage_npe', $scope.strings.saveSyncSettingsError );
                }
            );
        };

        /**
         * Method determines if all the visible sign up checkboxes are checked
         */
        var isAllChecked = function(){
            var checkCount = 0;
            var suLength = $scope.npeSignups.length;

            //count the number of checked items
            for(var i=0; i<suLength; i++){
                if( $scope.npeSignups[i].issynced == true ){ checkCount++; }
            }

            //If all items are checked, then toggle the Check All control
            $scope.frmObj.checkAll = ( checkCount == suLength );
        };

        /**
         * Method selects/checks all items when the check all box is checked
         */
        var checkAll = function(){
            $timeout(function(){
                for(var i=0, len=$scope.npeSignups.length; i<len; i++){
                    if( !$scope.npeSignups[i].isrsvp ){
                        $scope.npeSignups[i].isactive = $scope.frmObj.checkAll;
                    }
                }

                // re-prep $scope data
                $scope.npeSignupsFiltered = angular.copy( $scope.npeSignups );
                $scope.recordCount = $scope.npeSignupsFiltered.length;
                filterData();
            },50);
        };

        /**
         * Method verifies the default sync settings
         */
        var validateDefaultSyncSettings = function(){
            var deferred = $q.defer();

            //clear errors and error classes
            $scope.es.clearErrors();

            //verify the user provided a valid value for default hours
            if($scope.sync.volunteer.slots == 'defaulthours'){
                if( isNaN( parseFloat($scope.sync.volunteer.hours) ) ){
                    $scope.es.setError('manage_npe', 'no msg');
                    $scope.es.setError('field_hours', 'no msg');
                }
            }

            if( $scope.es.hasErrors ){
                //toggle spinner and form disable
                SUGUtilities.broadCast('isProcessing', false);
                $window.scrollTo(0,0);
                deferred.reject();
            }else{
                deferred.resolve(true);
            }
            return deferred.promise;
        };

        /**
         * Method verifies the data in the save array
         * This is a little overkill there is no uncontroller user input. Objects saved are the objects loaded.
         * However, in the even something went wrong, this should check it.
         * Just use a generic error since there are no specific form fields to identify.
         */
        var validateSignupData = function(){
            var deferred = $q.defer();

            //clear errors and error classes
            $scope.es.clearErrors();

            for(var i=0, len=signupsToSave.length; i<len; i++){
                var su = signupsToSave[i];
                var genericError = $filter('sugString')($scope.strings.validationError, [{'signupName': su.title}]);

                // validate listId is a valid number
                if( typeof su.listid == 'undefined'){
                    $scope.es.setError('manage_npe', genericError );
                } else if( !(angular.isNumber(su.listid) && isFinite(su.listid)) || su.listid <= 0 ){
                    $scope.es.setError('manage_npe', genericError );
                }

                // validate syncTypeId is a valid number
                if( typeof su.synctypeid == 'undefined'){
                    $scope.es.setError('manage_npe', genericError );
                } else if( !(angular.isNumber(su.synctypeid) && isFinite(su.synctypeid)) || su.synctypeid <= 0 ){
                    $scope.es.setError('manage_npe', genericError );
                }

                // validate syncSettings - verify the property. Values may be empty string, "{}", or actual settings
                if( typeof su.syncsettings == 'undefined'){
                    $scope.es.setError('manage_npe', genericError );
                }

                // validate isActive is a valid bit number
                if( typeof su.isactive == 'undefined'){
                    $scope.es.setError('manage_npe', genericError );
                } else if( !(angular.isNumber(su.isactive) && isFinite(su.isactive)) || su.isactive < 0  || su.isactive > 1 ){
                    $scope.es.setError('manage_npe', genericError );
                }
            }

            if( $scope.es.hasErrors ){
                //toggle spinner and form disable
                SUGUtilities.broadCast('isProcessing', false);
                $window.scrollTo(0,0);
                deferred.reject();
            }else{
                deferred.resolve();
            }
            return deferred.promise;
        };

        /**
         * Method updates the object array used for saving
         * Only save sign ups that meet the criteria of:
         * 1 - are marked active
         * 2 - have custom sync settings (ie. not default)
         * 3 - were saved previosuly (in case the user marks a default/active SU to inactive)
         */
        var updateSaveArray = function(){
            var deferred = $q.defer();

            for(var i=0, len=$scope.npeSignups.length; i<len; i++){
                if(    $scope.npeSignups[i].isactive
                    || !$scope.npeSignups[i].isdefault
                    || $scope.npeSignups[i].integrationsyncid > 0
                    || $scope.npeSignups[i].synctypekey != $scope.npeSignups[i].originalsynctypekey
                ){
                    var su = angular.copy($scope.npeSignups[i]);

                    //convert the booleans back to bit
                    su.isdefault = su.isdefault ? 1 : 0;
                    su.isactive = su.isactive ? 1 : 0;

                    //default sync settings for newly checked signups
                    su.syncsettings = su.syncsettings.toString().length ? su.syncsettings : '{}';

                    //find the SU in the saveArray
                    var lkup = $filter('filter')(signupsToSave, {listid: su.listid});

                    if( lkup.length ){
                        //if the SU is already in the array, just overrite it
                        var idx = signupsToSave.indexOf( lkup[0] );
                        signupsToSave[idx] = su ;
                    } else {
                        //otherwise add it
                        signupsToSave.push( su );
                    }
                }
            }

            deferred.resolve(true);
            return deferred.promise;
        };





        /************************
         EXPOSED FUNCTIONS
        ************************/

        $scope.disable = function(){
            //show confirmation modal
            SUGUtilities.showConfirmationModal({
                txtConfirmationTitle: $scope.strings.confirmTitle,
                txtConfirmationMessage: '<span class="enforce-wrap" style="white-space:pre-wrap;">' + $scope.strings.disableConfirmBody + '</span>',
                lblYesButton: $scope.strings.disableConfirmButton,
                lblCancelButton: ''
            }, function () {
                SUGUtilities.broadCast('isProcessing', true);
                // Modal Confirmed
                integrationService.disableNPE({ memberid: _userdef.memberid } )
                    .then(function (response) {
                        if (SUGUtilities.ajaxResultInvalid(response)) {
                            // error deleting
                            $scope.es.setError('manage_npe', SUGUtilities.getAjaxResponseMessage(response) );
                            SUGUtilities.broadCast('isProcessing', false);
                            $uibModalInstance.dismiss();
                        } else {

                            //after NPE is successfully disabled, remove the user's table settings and Default sync settings
                            var idList = $scope.syncSettingID + ',' + $scope.settingID;
                            settingService.deleteSettings({ ids:idList  } )
                            .then(function (response) {
                                if (SUGUtilities.ajaxResultInvalid(response)) {
                                    // error deleting
                                    $scope.es.setError('manage_npe', SUGUtilities.getAjaxResponseMessage(response) );
                                    SUGUtilities.broadCast('isProcessing', false);
                                } else {
                                    //clear the table and default sync settings
                                    $scope.syncSettingID = 0;
                                    $scope.sync = {};
                                    sugCacheFactory.set( 'sync', $scope.sync );

                                    $scope.settingID = 0;
                                    $scope.frmObj = {};
                                    sugCacheFactory.set('frmObj',$scope.frmObj);

                                    //update the status message, manage button on the main integrations page, and reset the tokens
                                    $scope.$parent.sug_integrations.statusmsg.text = $scope.strings.disableSuccessMsg;
                                    $scope.$parent.sug_integrations.statusmsg.show = true;
                                    $scope.$parent.sug_integrations.updateManageBtn('npe','Sign in with NonProfitEasy',false);
                                    $scope.$parent.sug_integrations.resetNpeTokens();

                                    //wrapped in a $timeout to allow the $watchers time to digest before we reset diritness
                                    $timeout(function(){
                                        // reset dirtiness since everything has been cleared
                                        initializeDirtiness();

                                        //return to the main settings page
                                        SUGUtilities.broadCast('isProcessing', false);
                                        $location.path( "/" );
                                    },50);
                                }
                            });
                        }
                });

                return;
            });
        };

        $scope.save = function(cb){
            SUGUtilities.broadCast('isProcessing', true);

            //clear any previous status messages
            $scope.statusmsg_npe.text = '';
            $scope.statusmsg_npe.show = false;
            // set callback if provided
            cb = cb || angular.noop;

            validateDefaultSyncSettings()
            .then(function(){

                validateSignupData()
                .then(function(){

                    updateSaveArray()
                    .then(function(){

                        integrationService.saveNPESignups({ signups: signupsToSave , memberid: _userdef.memberid } )
                        .then(function(response) {
                            if (SUGUtilities.ajaxResultInvalid(response)) {
                                // error deleting
                                $scope.es.setError('manage_npe', SUGUtilities.getAjaxResponseMessage(response) );
                                SUGUtilities.broadCast('isProcessing', false);
                                $window.scrollTo(0,0);
                            } else {
                                var r = SUGUtilities.lowerCaseKeys(response);
                                if (r.data && r.data.success) {

                                    //Update the save array with the updated data;
                                    //Essentially this will pick up any new integrationSyncIds
                                    signupsToSave = r.data.data;

                                    //go through the saved records and apply those updated IDs to the displayed data
                                    for(var i=0, len=signupsToSave.length; i<len; i++){
                                        var signup = $filter('filter')($scope.npeSignups, { listid: signupsToSave[i].listid })[0];
                                            signup.integrationsyncid = signupsToSave[i].integrationsyncid;
                                    }

                                    // success - set status message
                                    $scope.statusmsg_npe.text = $scope.strings.saveSuccessMsg;
                                    $scope.statusmsg_npe.show = true;
                                    $window.scrollTo(0,0);
                                    // reset dirtiness
                                    initializeDirtiness();
                                    // fire callback
                                    cb();
                                }
                            }

                            //run this last bc it behaves differently in regard to promises
                            saveDefaultSyncSettings();

                            SUGUtilities.broadCast('isProcessing', false);
                        }); // END saveNPESignups

                    }); // END updateSaveArray

                }); // END validateSignupData

            }); // END validateDefaultSyncSettings
        };

        $scope.cancel = function(){
            $location.path( "/" );
        };

        $scope.docheck = function(){
            isAllChecked();
            $scope.dirty = true;
        };

        $scope.docheckall = function(){
            checkAll();
            $scope.dirty = true;
        };

        $scope.dosettings = function( su ){
            if( su.synctypekey == 'VOL' ){
                showVolSettingsModal( su );
            }
        };

        $scope.resync = function( evt, su ){
            if(!su.isrsvp && !$scope.frmDisableChecks){

                //make the resync icon spin :)
                /* DECIDED TO NOT ANIMATE FOR NOW
                if( typeof evt.currentTarget != 'undefined'
                    && typeof evt.currentTarget.childNodes != 'undefined'
                    && evt.currentTarget.childNodes.length > 1 ){

                    var resyncicon = evt.currentTarget.childNodes[1];
                        resyncicon.classList.add("sugicon-spin");
                }
                */

                //show confirmation modal
                SUGUtilities.showConfirmationModal({
                    txtConfirmationTitle: $scope.strings.confirmTitle,
                    txtConfirmationMessage: '<span class="enforce-wrap" style="white-space:pre-wrap;">' + $scope.strings.syncConfirmBody + '</span>',
                    lblYesButton: $scope.strings.syncConfirmButton,
                    lblCancelButton: ''
                }, function () {
                    // Modal Confirmed
                    SUGUtilities.broadCast('isProcessing', true);

                    integrationService.resyncNPE( { signup: su , memberid: _userdef.memberid } )
                        .then(function (response) {
                            if (SUGUtilities.ajaxResultInvalid(response)) {
                                // error
                                $scope.es.setError('manage_npe', SUGUtilities.getAjaxResponseMessage(response) );
                            } else {
                                // success - set status message.
                                $scope.statusmsg_npe.text = $scope.strings.syncSuccessMsg;
                                $scope.statusmsg_npe.show = true;
                            }
                            SUGUtilities.broadCast('isProcessing', false);

                            //if the resync icon is spinning, stop it. Give a little delay so the user sees it.
                            /* DECIDED TO NOT ANIMATE FOR NOW
                            if( typeof resyncicon != 'undefined' ){
                                $timeout(function() {
                                    resyncicon.classList.remove("sugicon-spin");
                                }, 1000);
                            }
                            */
                    });
                    return;
                }, function () {
                    // Modal Dismissed
                    //if the resync icon is spinning, stop it. Give a little delay so the user sees it.
                    if( typeof resyncicon != 'undefined' ){
                        $timeout(function() {
                            resyncicon.classList.remove("sugicon-spin");
                        }, 1000);
                    }
                    return;
                });
            }
        };

        $scope.changesynctype = function( su ){
            if( su.syncdateformatted.toString().toLowerCase() != 'never' ){
                var newTypeKey = $filter('filter')($scope.synctypes, {typekey: su.synctypekey})[0].typekey;
                var newTypeLbl = newTypeKey == 'VOL' ? 'Volunteering' : 'General Event';
                var oldTypeLbl = newTypeLbl == 'General Event' ? 'Volunteering' : 'General Event';

                //show confirmation modal
                SUGUtilities.showConfirmationModal({
                    txtConfirmationTitle: $scope.strings.confirmTitle,
                    txtConfirmationMessage: '<span class="enforce-wrap" style="white-space:pre-wrap; hyphens:initial">' +
                        $filter('sugString')($scope.strings.changeSyncConfirmBody, [{'oldType': oldTypeLbl},{'newType': newTypeLbl}]) +
                        '</span>',
                    lblYesButton: $scope.strings.changeSyncConfirmButton,
                    lblCancelButton: ''
                }, function () {
                    // Modal Confirmed
                    SUGUtilities.broadCast('isProcessing', true);

                    integrationService.changeNPESyncType( { signup: su, memberid: _userdef.memberid } )
                        .then(function (response) {
                            if (SUGUtilities.ajaxResultInvalid(response)) {
                                // error
                                $scope.es.setError('manage_npe', SUGUtilities.getAjaxResponseMessage(response) );
                                SUGUtilities.broadCast('isProcessing', false);
                            } else {
                                // success
                                //update the sync settings
                                toggleSuSettings( su, true );

                                //update the database
                                integrationService.saveNPESyncSettings({ signups: {
                                                                            listId:su.listid
                                                                            , syncTypeId:su.synctypeid
                                                                            , syncSettings:su.syncsettings
                                                                            , isActive:su.isactive ? 1 : 0
                                                                            , jobid:0   //Lumaverse service knows to treat 0 as 'NULL'
                                                                            }
                                                                    , memberid: _userdef.memberid
                                                                })
                                .then(function (response) {
                                    if (SUGUtilities.ajaxResultInvalid(response)) {
                                        // invalid response, show error
                                        $scope.es.setError('manage_integrations', SUGUtilities.getAjaxResponseMessage(response) );
                                    } else {
                                        // success
                                        //Set status message
                                        $scope.statusmsg_npe.text = $scope.strings.syncTypeChgSuccessMsg;
                                        $scope.statusmsg_npe.show = true;
                                    }
                                    SUGUtilities.broadCast('isProcessing', false);
                                });
                            }
                    });
                    return;

                }, function () {
                    // Modal Dismissed - reset select value
                    su.synctypekey = newTypeKey == 'VOL' ? 'GEN' : 'VOL';
                    return;
                });
            } else {
                // set dirty
                $scope.dirty = true;
                //update the settings
                toggleSuSettings( su );
            }
        };

        $scope.errordetails = function( su ){
            //show confirmation modal
            SUGUtilities.showConfirmationModal({
                txtConfirmationTitle: $scope.strings.errorDetailTitle,
                txtConfirmationMessage: '<span class="enforce-wrap" style="white-space:pre-wrap; hyphens:initial">' +
                    $sce.trustAsHtml( $filter('sugString')($scope.strings.errorDetailConfirmBody, [{'errorText': su.jobresult.trim()}]) ) +
                    '</span>',
                lblYesButton: $scope.strings.errorDetailConfirmButton,
                lblCancelButton: ''
            }, function () {
                SUGUtilities.broadCast('isProcessing', true);
                // Modal Confirmed
                integrationService.resetNPESyncJob({ jobid: su.jobid } )
                    .then(function (response) {
                        if (SUGUtilities.ajaxResultInvalid(response)) {
                            // error resetting job
                            $scope.es.setError('manage_npe', SUGUtilities.getAjaxResponseMessage(response) );
                            SUGUtilities.broadCast('isProcessing', false);
                            $uibModalInstance.dismiss();
                        }  else {
                            // success
                            // Update the data models
                            var updatedsu = angular.copy( su );
                                updatedsu.jobstatus = 'Pending';
                                updatedsu.syncdateformatted = 'Pending';
                                updatedsu.lastjobstartdate = new Date().toLocaleString();
                            updateSignUpModels( updatedsu );

                            //Set status message
                            $scope.statusmsg_npe.text = $scope.strings.resetSyncJobSuccessMsg;
                            $scope.statusmsg_npe.show = true;
                        }
                        SUGUtilities.broadCast('isProcessing', false);
                        $window.scrollTo(0,0);
                });

                return;
            });
        };

        /**
         * Updates properties of the sign up object based on other settings.
         * @param {object} su - REQUIRED; valid sign up object from the view's sign up sync table
         * @param {boolean} reset - Optional; Determins if the sync settings are reset; Used when Sync Type is changed by the user.
         */
        var toggleSuSettings = function( su, reset ){
            resetSettings = typeof reset != 'undefined' ? reset : false;

            su.synctypeid = su.synctypekey == 'VOL' ? 2 : 1;

            if( su.synctypekey == 'GEN' || resetSettings ){
                su.syncsettings = '{}';
            }
            if( su.syncsettings == '{}' ){
                su.isdefault = true;
            }

            //runs when the user changes the SU sync type
            if( resetSettings ){
                var resetsu = angular.copy( su );
                    resetsu.jobstatus = "";
                    resetsu.jobresult = "";
                    resetsu.lastjobcompletedate = "";
                    resetsu.lastjobstartdate = "";
                    resetsu.lastsyncepoch = "";
                    resetsu.lastsyncsuccessepoch = "";
                    resetsu.syncdateformatted = "Never";
                updateSignUpModels( resetsu );
            }
        };

        /**
         * Updates (replaces) a sign up object in the view models
         * @param {object} su - REQUIRED; valid sign up object from the view's sign up sync table
         */
        var updateSignUpModels = function( su ){
            if( typeof su != 'undefined' && Object.keys(su).length ){
                //remove the original su object
                $scope.npeSignups = $filter('filter')($scope.npeSignups, function (o) {
                    return o.listid !== su.listid;
                }, true);

                //replace it with the updated model
                $scope.npeSignups.push( su );

                //rebuild the view model
                $scope.npeSignupsFiltered = angular.copy( $scope.npeSignups );
                $scope.recordCount = $scope.npeSignupsFiltered.length;
                filterData();
            }
        };

        /**
         * Method determines if the sign up has an active volunteering settings gear
         * @param {object} su - REQUIRED; valid sign up object from the view's sign up sync table
         */
        $scope.disablegear = function( su ){
            return su.synctypekey != 'VOL';
        };

        /**
         * Method determines if the sign up settings gear is grey or not
         * @param {object} su - REQUIRED; valid sign up object from the view's sign up sync table
         */
        $scope.monogear = function( su ){
            return su.isdefault || su.synctypekey != 'VOL' ;
        };

        /**
         * Method determines if the length of the default hours form field should be 3 or 4 characters
         * Determine if the number is a flot by checking for the period, so 10.0 is valid
         */
        $scope.updatehours = function(){
            if( $scope.sync.volunteer.hours != 'undefined' && typeof $scope.sync.volunteer.hours != 'object'){
                $scope.hoursmax = $scope.sync.volunteer.hours.includes('.') ? 4 : 3;
            } else {
                $scope.hoursmax = 3;
            }
        };

        /**
         * Helper method to generate a link to a sign up page
         *
         * @urlid - String, Required - Valid urlid of the sign up the link is for
         */
        $scope.getSignupLink = function ( urlid ){
            var link = '';
            if( typeof urlid !== 'undefined' && urlid.toString().length ){
                link = $scope.fullsecureurl + '/go/' + urlid.toString().trim();
            }
            return link;
        };


        /************************
         MODAL: VOLUNTEER SETTINGS
        ************************/
        var showVolSettingsModal = function ( su ) {
            $uibModal.open({
                templateUrl: 'view/members/integrations/npe-modal-volunteer-settings.html',
                controller: 'npeVolSettingsModalController',
                resolve: {
                    //pass data into the modal
                      volsignup: function(){ return su; }
                    , voltext: function(){ return $scope.strings.volunteer; }
                }
            }).result.then(function (response) {
                SUGUtilities.broadCast('isProcessing', true);

                //grab the updated settings
                var newsyncsettings = response.newsyncsettings;
                var suid = response.volsignupid;

                if(    typeof suid == 'undefined'
                    || typeof newsyncsettings == 'undefined'
                    || !Object.keys( newsyncsettings ).length )
                {
                    // error passing information back from the modal
                    $scope.es.setError('manage_npe', $scope.strings.volunteer.settingserror );
                    SUGUtilities.broadCast('isProcessing', false);
                } else {
                    //find the signup in the data model
                    var volsignup = $filter('filter')($scope.npeSignups, {listid: suid})[0];

                    //if new settings say use default, then clear the settings
                    if( newsyncsettings.volunteer.slots == 'usedefault'){
                        volsignup.syncsettings = "{}";
                        volsignup.isdefault = true;
                    } else {
                        //esle update the sync settings to match the new changes
                        volsignup.syncsettings = JSON.stringify( newsyncsettings );
                        volsignup.isdefault = false;
                    }

                    //update the database
                    integrationService.saveNPESyncSettings({ signups:{
                                                                listId:volsignup.listid
                                                                , syncTypeId:volsignup.synctypeid
                                                                , syncSettings:volsignup.syncsettings
                                                                , isActive:volsignup.isactive ? 1 : 0
                                                                }
                                                            , memberid: _userdef.memberid
                                                        })
                    .then(function (response) {
                        if (SUGUtilities.ajaxResultInvalid(response)) {
                            // invalid response, show error
                            $scope.es.setError('manage_integrations', SUGUtilities.getAjaxResponseMessage(response) );
                        } else {
                            // success - set status message and return to integrations page.
                            $scope.statusmsg_npe.text = $scope.strings.saveVolSuccessMsg;
                            $scope.statusmsg_npe.show = true;
                        }
                        SUGUtilities.broadCast('isProcessing', false);
                    });
                }
            }, function () {
                //rejected
            });
        };

        /************************
        MODAL: SYNC ACTIVITY MODAL
        ************************/
        $scope.showSyncActivity = function( su ) {
            $uibModal.open({
                templateUrl: 'view/members/integrations/npe-modal-sync-activity.html',
                controller: 'syncActivityModalController',
                resolve: {
                    //pass data into the modal
                    signup: function(){ return su; }
                }
            });
        };


        /************************
         WATCHERS - DO NOT PREFIX $watchCollection vars w/ $scope (ex. $scope.frmObj)
        ************************/

        /**
         * WATCHER: slots; clear defaulthours when ignoreall is seleced
         */
        $scope.$watchCollection('sync.volunteer.slots', function (nVal, oVal) {
            if (nVal != oVal
                && typeof $scope.sync.volunteer !== 'undefined'
                && $scope.sync.volunteer.slots == 'ignoreall'
            ){
                // reset defaulthours
                $scope.sync.volunteer.hours = null;
            }
            // set dirty
            $scope.dirty = true;
        });

        /**
         * WATCHER: defaulthours; maintain numeric decimal value only
         */
        $scope.$watchCollection('sync.volunteer.hours', function (nVal, oVal) {
            if (nVal != oVal
                && typeof $scope.sync.volunteer !== 'undefined'
            ){
                // force min/max fields to be numeric decimal
                $scope.sync.volunteer.hours = isNaN( parseFloat($scope.sync.volunteer.hours) ) ? '' : parseFloat($scope.sync.volunteer.hours);

                // if hours has a value make sure the radio button is checked
                if( $scope.sync.volunteer.hours != '' ){
                    $scope.sync.volunteer.slots = 'defaulthours';
                }
                // set dirty
                $scope.dirty = true;
            }
        });

        /**
         * WATCHER: Pagination
         */
        $scope.$watch('pagination.currentPage + pagination.numPerPage', function () {
            filterData();
        });

        /**
         * WATCHER: frmObj for sorting, filtering, search, setting changes
         */
        $scope.$watchCollection('frmObj', function (nVal, oVal) {
            var newVal = angular.copy(nVal);
            var oldVal = angular.copy(oVal);

            // validate number per page (stop processing if empty or invalid since we must have it for proper filter/sort)
            if (!$scope.frmObj.numPerPage || $scope.frmObj.numPerPage.toString().trim() === '') {
                return;
            } else if (!(angular.isNumber(~~$scope.frmObj.numPerPage) && isFinite(~~$scope.frmObj.numPerPage)) || ~~$scope.frmObj.numPerPage <= 0) {
                SUGUtilities.showMagnificAlert($scope.strings.itemsPerPageInvalid, 'error', '', 'Sorry!');
                $scope.frmObj.numPerPage = oldVal.numPerPage;
                return;
            }

            /* Apply Filter - Filter through the data Array, NOT the filtered data */
            $scope.npeSignupsFiltered = $filter('orderBy')($scope.npeSignups, $scope.frmObj.orderColumn, $scope.frmObj.direction);

            /* Update Settings in Factory */
            sugCacheFactory.set( 'frmObj', angular.copy($scope.frmObj) );
            prepareUserSettings();

            /* Apply Search Filter if Present - Filter through the data Array, NOT the filtered data */
            if (newVal.searchFilter != oldVal.searchFilter) {
                $scope.npeSignupsFiltered = $filter('filter')($scope.npeSignups, $scope.searchNpeSignups);
                $scope.npeSignupsFiltered = $filter('orderBy')($scope.npeSignupsFiltered, $scope.frmObj.orderColumn, $scope.frmObj.direction);
                $scope.recordCount = $scope.npeSignupsFiltered.length;
            } else {
                filterData();
            }
        });

        /**
         * WATCHER: Integration Settings checkbox
         */
        $scope.$watch('sync.general.syncall', function (nVal, oVal) {
            if( nVal != oVal && typeof oVal !== 'undefined' ){
                $scope.dirty = true;
            }
        });

        /**
         * BINDING: Sign Up Title Truncation
         */
        angular.element($window).bind('resize', function() {
            $timeout(function() {
                //SM/MD: 28 chars / LG: 58 chars
                $scope.commentlen = $window.innerWidth < 1200 ? 28 : 58;
            });
        });

        /************
        * DIRTINESS HANDLING
        ************/
       /**
         * Set / reset dirtiness
         *
         */
        var initializeDirtiness = function() {
            $scope.dirty = false;
        };
       /**
         * If navigating away per internal menus, confirm discard
         *
         */
        // set areas to watch for click
        var $navigateContainers = $('.profile-settings--tabs, header, #protoolsbar, footer, .sub-footer');
        var $clickTargets = $('button, a',$navigateContainers).not('.dropdown-toggle');
        // gets corresponding link for subsequent fire
        var findClosestClickableElement = function (element,includeElement) {
            if(includeElement && element.click){
                return element;
            } else {
                while ((element = element.parentElement) && !element.click);
                return element;
            }
        };
        /**
         * Click interceptor to test for dirtiness and warn user of discard
         *
         */
        var clickInterceptHandler = function(e){
            if ( $scope.dirty ) {
                e.preventDefault();
                e.stopPropagation();
                // make sure it is okay to abandon changes
                confirmAbandonChanges()
                .then(function ( response ) {
                    if( response ){
                        // saving changes
                        var callback = function(){
                            // turn off the click intercept
                            $clickTargets.off('click',clickInterceptHandler);
                            // trigger the click again on nearest HTMLElement
                            findClosestClickableElement(e.target,true).click();
                        };
                        $scope.save(callback);
                    }
                    else {
                        // turn off the click intercept
                        $clickTargets.off('click',clickInterceptHandler);
                        // trigger the click again on nearest HTMLElement
                        findClosestClickableElement(e.target,true).click();
                    }
                }, function () {
                    // canceled
                    return false;
                });
            }
        };
        $clickTargets.on('click',clickInterceptHandler);

        /**
         * Confirm whether to abandon changes.
         *
         * @returns {Promise}
         */
        var confirmAbandonChanges = function() {
            var deferred = $q.defer();

            // confirm if user wants to abandon changes
            SUGUtilities.showConfirmationModal({
                txtConfirmationTitle: 'Warning!',
                txtConfirmationMessage: 'You have unsaved changes.',
                lblYesButton: 'Save & Proceed',
                lblAltButton: 'Discard & Proceed',
                lblCancelButton: ''
            },
            function ( response ) { // fnConfirmed
                if( response ){
                    // save and continue
                    deferred.resolve(true);
                }
                else {
                    // discard & continue
                    deferred.resolve(false);
                }
            },
            function () { //fnDismissed
                deferred.reject(false);
            });

            return deferred.promise;
        };

        init();
    }
}());




/**************************************************
 MODAL CONTROLLER: npeVolSettingsModalController
**************************************************/
(function(){
    // add the controller
    SUGApp.controller('npeVolSettingsModalController', npeVolSettingsModalController);
    npeVolSettingsModalController.$inject = [ '$scope','$uibModalInstance','$filter','$location','$q','SUGUtilities','sugCacheFactory','errorService','globalService','integrationService','volsignup','voltext' ];
    function npeVolSettingsModalController(    $scope, $uibModalInstance, $filter, $location, $q, SUGUtilities, sugCacheFactory, errorService, globalService, integrationService, volsignup, voltext ){

        $scope.isProcessingModal = false;
        $scope.frmDisableField = false;
        $scope.su = volsignup;
        $scope.sync = {};
        $scope.hoursmax = 3;

        /* View Specific Modal Strings */
        $scope.strings = {
              buttonSave:   'Save'
            , errors:   {
                  errorsTitle:  ''
                , errorsPleaseCorrect:  'Please correct the following issues:'
            }
        };

        /* Volunteer text is the same, so it's shared from main controller */
        $scope.strings['volunteer'] = voltext;

        /* init error service */
        $scope.modal_es = errorService.newInstance();
        $scope.modal_es.init();
        $scope.modal_es.clearErrors();


        /* uibPopover vars */
        $scope.popover = {
            popTrig: 'mouseenter',
            popPlacement: 'top',
            popDelay: 300,
            appendToBody: false
        };

        //form model
        $scope.frm = {
            commentlen: 57
        };

        // Handler for Processing Status
        $scope.$on('isProcessingModal', function (event, isProcessingModal) {
            $scope.isProcessingModal = isProcessingModal;

            disableForm(isProcessingModal);

            if ($scope.isProcessingModal) {
                SUGUtilities.showLoading('processing');
            }
        });

        /**
         * Start page flow
         */
        var init = function(){
            //parse the sync settings
            if( $scope.su.syncsettings.toString().length && $scope.su.syncsettings != '{}' ){
                $scope.sync = JSON.parse( $scope.su.syncsettings );
            } else {
                //Note: "usedefault" isn't saved back to the database, its only used in the form.
                $scope.sync = JSON.parse( '{"volunteer":{"slots":"usedefault","hours":""}}' );
            }
        };

        //manage disabling the form
        var disableForm = function (blnDisabled) {
            $scope.frmDisableField = blnDisabled;
        };

        /**
         * Method verifies the custom volunteer sync settings
         */
        var validateVolSettings = function(){
            var deferred = $q.defer();

            //clear errors and error classes
            $scope.modal_es.clearErrors();

            //verify the user provided a valid value for default hours
            if($scope.sync.volunteer.slots == 'defaulthours'){
                if( isNaN( parseFloat($scope.sync.volunteer.hours) ) ){
                    $scope.modal_es.setError('err_volsettings', 'no msg');
                    $scope.modal_es.setError('modal_field_hours', 'no msg');
                }
            }

            if( $scope.modal_es.hasErrors ){
                //toggle spinner and form disable
                SUGUtilities.broadCast('isProcessingModal', false);
                deferred.reject();
            }else{
                deferred.resolve();
            }
            return deferred.promise;
        };


        /************************
         MODAL EXPOSED FUNCTIONS
        ************************/
        $scope.dismiss = function () {
            $uibModalInstance.dismiss(false);
        };

        /**
         * Method determines if the length of the default hours form field should be 3 or 4 characters
         * Determine if the number is a flot by checking for the period, so 10.0 is valid
         */
        $scope.updatehours = function(){
            if( $scope.sync.volunteer.hours != 'undefined' && typeof $scope.sync.volunteer.hours != 'object'){
                $scope.hoursmax = $scope.sync.volunteer.hours.includes('.') ? 4 : 3;
            } else {
                $scope.hoursmax = 3;
            }
        };

        /**
         * Return form data to the main controller
         * No need for validations as the form is only radio controls
         */
        $scope.save = function(){
            SUGUtilities.broadCast('isProcessingModal', true);

            validateVolSettings()
            .then(function(){
                $uibModalInstance.close({
                    newsyncsettings: $scope.sync
                  , volsignupid: $scope.su.listid
                });
            });

            SUGUtilities.broadCast('isProcessingModal', false);
        };


        /************************
         MODAL WATCHERS
        ************************/
        /**
         * WATCHER: slots; clear defaulthours when ignoreall is seleced
         */
        $scope.$watchCollection('sync.volunteer.slots', function (nVal, oVal) {
            if (nVal != oVal
                && typeof $scope.sync.volunteer !== 'undefined'
                && ( $scope.sync.volunteer.slots == 'usedefault' || $scope.sync.volunteer.slots == 'ignoreall' )
            ){
                // reset defaulthours
                $scope.sync.volunteer.hours = null;
            }
        });

        /**
         * WATCHER: defaulthours; maintain numeric decimal value only
         */
        $scope.$watchCollection('sync.volunteer.hours', function (nVal, oVal) {
            if (nVal != oVal
                && typeof $scope.sync.volunteer !== 'undefined'
            ){
                // force min/max fields to be numeric decimal
                $scope.sync.volunteer.hours = isNaN( parseFloat($scope.sync.volunteer.hours) ) ? '' : parseFloat($scope.sync.volunteer.hours);

                // if hours has a value make sure the radio button is checked
                if( $scope.sync.volunteer.hours != '' ){
                    $scope.sync.volunteer.slots = 'defaulthours';
                }
            }
        });

        init();
    }
}());